// Entry point for the build script in your package.json
import '@hotwired/turbo-rails'
import './controllers'
import 'flowbite/dist/flowbite.turbo.js'
import './icon'
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

const cleanupModalArtifacts = () => {
  document.querySelectorAll('[modal-backdrop], [data-modal-backdrop], .modal-backdrop').forEach((el) => el.remove())
  document.body.classList.remove('overflow-hidden')
  document.body.classList.remove('md:overflow-hidden')
  document.body.classList.remove('overflow-y-hidden')
  document.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close())
}

document.addEventListener('turbo:before-cache', cleanupModalArtifacts)
document.addEventListener('turbo:before-render', cleanupModalArtifacts)
document.addEventListener('turbo:before-frame-render', cleanupModalArtifacts)
document.addEventListener('turbo:frame-load', cleanupModalArtifacts)

document.addEventListener('click', (event) => {
  const openButton = event.target.closest('[data-dialog-open]')
  if (openButton) {
    const dialog = document.getElementById(openButton.dataset.dialogOpen)
    if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal()
    }
    return
  }

  const closeButton = event.target.closest('[data-dialog-close]')
  if (closeButton) {
    const dialog = document.getElementById(closeButton.dataset.dialogClose)
    if (dialog && typeof dialog.close === 'function') {
      dialog.close()
    }
  }
})

document.addEventListener('click', (event) => {
  const dialog = event.target
  if (dialog instanceof HTMLDialogElement && dialog.open && event.target === dialog) {
    dialog.close()
  }
})

//fixing focus issue after closing modal
document.addEventListener('turbo:load', () => {
  document.addEventListener('click', (event) => {
    const hideButton = event.target.closest('[data-modal-hide]');
    if (hideButton) {
      hideButton.blur();
      
      document.body.focus();
    }
  });
});
